<!-- =========================================================================================
    File Name: DeviceExcelImport.vue
    Description: Dashcam Excel import popup
========================================================================================== -->

<template>
  <div>
    <vs-popup :title="$t('DEVICE_EXCEL_UPLOAD')" :active.sync="isPopupActiveLocal">
      
      <div class="tab-text">
        <div class="m-5">
          <span class="text-danger text-sm">* {{this.$t('CHECK_EXCEL_EXTENSION_MESSAGE')}}</span> <br />
          <span class="text-danger text-sm">* {{this.$t('CHECK_EXCEL_FILE_COUNT_MESSAGE')}}</span> <br />
          <span class="text-danger text-sm font-bold">* {{this.$t('CHECK_EXCEL_FORMAT_MESSAGE')}}</span>
          <import-excel :onSuccess="loadData" />
          <vs-alert v-if="fileName != ''" active="true" class="mt-5" icon-pack="feather" icon="icon-check-circle">
            <span class="font-bold">{{ fileName }}</span> {{this.$t('UPLOAD_FILE_SUCCESS')}}
          </vs-alert>
          <vs-alert v-if="isErrorExist" active="true" color="danger" class="mt-5" icon-pack="feather" icon="icon-info" >
              <span> {{this.errorAlertMessage}} </span>
          </vs-alert>
        </div> 

        <vs-divider />

        <div class="float-right">
          <vs-button class="mr-5"  @click="checkValidation" :disabled="isErrorExist">{{$t('UPLOAD')}}</vs-button>
          <vs-button type="border" color="danger" @click.stop="isPopupActiveLocal = false">{{$t('CLOSE')}}</vs-button>
        </div>
      </div>

      <vs-popup class="sidebar-popup"  :title="this.$t('CONFIRM')" :active.sync="confirmPopup">
        <p>{{this.$t('UPLOAD_CONFIRM_MESSAGE')}}</p>
        <div class="float-right mt-5">
          <vs-button @click="acceptAdd()" color="danger" type="filled">{{this.$t('CONFIRM')}}</vs-button>
          <vs-button @click="confirmPopup = false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
        </div>
      </vs-popup>

    </vs-popup>
  </div>
</template>

<script>
import ImportExcel from "@/components/excel/ImportExcel.vue"

export default {
  components: {
    ImportExcel
  },
  props: {
    isPopupActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  computed: {
    isPopupActiveLocal: {
      get() {
        return this.isPopupActive
      },
      set(val) {
        if (!val) {
          this.$emit('close')
          this.initValues()
        }
      }
    },
  },
  data() {
    return {
      fileName: "",
      excelData: [],
      header: [],
      sheetName: "",

      headerVal: ["DEVICE_UUID"],
      duplicatedDeviceFileName: "DUPLICATE_DEVUCE_UUID_LIST",
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: [this.$t("DUPLICATE_DEVUCE_UUID")],

      confirmPopup: false,
      isErrorExist: false,
      errorAlertMessage: ""
    }
  },
  methods: {
    loadData({ results, header, meta , fileName}) {
      this.initValues()
      let checkPattern = this.checkPattern(results)
      if(!checkPattern) return 

      this.header = header
      this.fileName = fileName
      this.excelData = results
      this.sheetName = meta.sheetName
    },
    initValues(){
      this.fileName = "",
      this.excelData = [],
      this.header= [],
      this.sheetName = ""

      this.isErrorExist = false,
      this.errorAlertMessage = ""
    },
    popupClose(){
      this.confirmPopup = false
      this.initValues()
      this.$vs.loading.close()
    },
    checkValidation(){
      let checkFileExist = this.checkFileExist()
      if(checkFileExist){
        this.confirmPopup = true
      }
    },
    checkFileExist(){
      const data = this.excelData
      if (data.length == 0) {
        this.isErrorExist = true
        this.errorAlertMessage = this.$t('NO_DEVICE_DATA')
        return false
      }else{
        return true
      }
    },
    checkPattern(data){
      const regex = /^[A-Z]{6}[A-Z]{1}[0-9]{2}([0-9]|[A-Z]){1}[A-Z]{1}([1-9]|[A-C]){1}([0-9]|[A-Z]){4}$/
      const regex_securityKey = /^([A-Z]|[0-9]){8}$/i

      Object.keys(data).forEach(key => {
        let device = data[key]
        Object.keys(device).forEach(key2 => {
          if(!device[key2]){
              this.isErrorExist = true
              this.errorAlertMessage = this.$t('DEVICE_EXCEL_EMPTY_ENTRY')
              return false
          }else if(key2 === "DEVICE_UUID" && !regex.test(device[key2])){
              this.isErrorExist = true
              this.errorAlertMessage = '"' + device[key2] + '" '+this.$t('DEVICE_INVALID_FORMAT')
              return false
          }else if(key2 === "DEVICE_SECURITY_KEY" && !regex_securityKey.test(device[key2])){
              this.isErrorExist = true
              this.errorAlertMessage = '"' + device[key2] + '" '+this.$t('DEVICE_INVALID_FORMAT')
              return false
          }
        })
      })
      return true
    },
    acceptAdd(){

      const excelFile = this.fileName.split(".")
      const deviceInfo = {
        fileName : excelFile[0],
        deviceUUIDList : this.excelData
      }

      this.$vs.loading()
      this.$store.dispatch("dataDevice/updateDeviceUUIDByExcel", deviceInfo)
      .then((response) => {
        this.$parent.$refs.deviceTable.getData()
         if(!response.data.resultBody) {
          this.successAlert(this.$t("SUCCESS"),this.$t("ADD_DEVICE_SUCCESS"))
          this.popupClose()
          this.$emit('close')
        } else{
          this.exportToExcel(response.data.resultBody);
          this.popupClose()
          this.infoAlert(this.$t("INFO"),this.$t("DUPLICATE_DEVICE_UUID_MESSAGE_FOR_EXCEL")+this.$t("CHECK_DOWNLOAD_EXCEL_FILE_MESSAGE"))
        }
      })
      .catch(error => {
        this.popupClose()
        this.errorAlert("Error", error.message)
      })
    },
    exportToExcel(duplicateDevices) {
      import('@/vendor/Export2Excel').then(excel => {
        const list = duplicateDevices
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.$t(this.duplicatedDeviceFileName),
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
  }
}
</script>
